import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const OrdersPageFooter = lazy(() => import('./OrdersPageFooter'))

class OrdersPageFooterWebComponent extends ReactWebComponent {
  override render() {
    return (
      <RootProviders>
        <OrdersPageFooter />
      </RootProviders>
    )
  }
}

customElements.define('orders-page-footer', OrdersPageFooterWebComponent)
